module.exports = __webpack_public_path__ + "img/ssel2018-gold-medal.16917435.png";